import serviceBase from "./serviceBase";
import { EndPoint } from '../appConfig';

var UserService = Object.create(
  new serviceBase(EndPoint.Me)
);
UserService.getMyAccount = function () {
  return this.get();
};
export default UserService;